import React from 'react';
import styled, {keyframes} from 'styled-components';
import * as AppActions from '../../../AppActions';

function ProductItem(props) {
  const {product, onClick, mobile} = props;
  const [loaded, setLoaded] = React.useState(false);
  const soldout =
    product.stock_type !== 'always' &&
    product.stock_sold_amount >= product.stock_amount;

  const src = React.useMemo(() => {
    try {
      return product.images[0].expected_url;
    } catch (e) {
      return null;
    }
  }, [product.images]);

  return (
    <Wrapper loaded={loaded} mobile={mobile} onClick={onClick}>
      <div className="product-img">
        {!loaded && (
          <img
            className="loading"
            src={'/images/empty-img.png'}
            alt="product"
          />
        )}
        <img
          src={src}
          alt="product"
          loading="lazy"
          onLoad={() => {
            setLoaded(true);
          }}
        />
      </div>

      <div className="info">
        <h3>{AppActions.F(product, 'name')}</h3>
        <div style={{flex: 1}} />
        {soldout ? (
          <p
            style={{
              textAlign: 'right',
              color: 'var(--primaryColor)',
            }}>
            {AppActions.L('sold_out')}
          </p>
        ) : (
          <p>
            {!!product.original_price && (
              <span
                style={{
                  textDecoration: 'line-through',
                  marginRight: 10,
                }}>
                NT${product.original_price}
              </span>
            )}
            {!!product.price && <span>NT${product.price}</span>}
          </p>
        )}
      </div>
    </Wrapper>
  );
}

const shaking = keyframes`
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(30deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-30deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  // width: ${(props) => (props.mobile ? '160px' : '200px')};
  overflow: hidden;
  cursor: pointer;
  transition: 400ms;
  color: var(--text-3-color);

  & > .info {
    display: flex;
    flex-direction: column;
    //max-height: 120px;
    padding: 10px 0px;
    & > h3 {
      flex: 1;
      font-size: 14px;
      font-weight: 300;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: break-spaces;
      color: var(--text-3-color);
    }
  }
  & > .product-img {
    position: relative;
    background-color: #fff;
    width: 100%;
    overflow: hidden;
    aspect-ratio: 1;

    & > .loading {
      position: absolute;
      top: 0;
      left: 0;
      animation: ${shaking} 1000ms linear infinite;

      visibility: ${(props) => (props.loaded ? 'hidden' : 'visibale')};
      filter: blur(8px);
      transition: visibility 0ms ease-out 500ms;
    }

    & > img {
      width: 100%;
      height: 100%;
      object-fit: cover;

      opacity: ${(props) => (props.loaded ? 1 : 0)};
      transition: all 400ms ease-in 0ms;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;

export default ProductItem;
